import { Button } from "antd";
import React from "react";
import "./PlayButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";

function PlayButton({
  size = "",
  onClick,
  isPlaying = false,
  className = "",
  ...props
}) {
  // size: "xs", "sm", "md", "lg"
  return (
    <Button
      className={`playButton ${size} ${className}`}
      onClick={onClick}
      {...props}
    >
      {isPlaying ? (
        <FontAwesomeIcon icon={faPause} />
      ) : (
        <FontAwesomeIcon icon={faPlay} />
      )}
    </Button>
  );
}

export default PlayButton;
